import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { GuestWaitingList } from '@seaters/constants';
import {
  AppleLogo,
  GoogleLogo,
  isMobile,
  isSafari,
  OutlookLogo,
} from '@seaters/ui-shared';
import { useAddToCalendar } from './hooks';
import styles from './IxpoleGuestFlow.module.css';

const { Text } = Typography;

type CalendarPlatform = 'google' | 'outlook' | 'apple';

interface CalendarSelectionProps {
  waitingListData: GuestWaitingList;
}

export function CalendarSelection({ waitingListData }: CalendarSelectionProps) {
  const { t } = useTranslation();
  const { openAppleCalendar, openGoogleCalendar, openOutlookCalendar } =
    useAddToCalendar({ waitingListData });

  const handleAddToCalendar = (platform: CalendarPlatform) => {
    if (platform === 'apple') {
      openAppleCalendar();
      return;
    }

    if (platform === 'google') {
      openGoogleCalendar();
      return;
    }

    openOutlookCalendar();
  };

  return (
    <div className={styles.calendarSection}>
      <Text className={styles.calendarTitle}>{t('guest_app_calendar')}</Text>
      <div className={styles.calendarActions}>
        {(!isMobile() || isSafari()) && (
          <button
            type="button"
            className={styles.calendarIconButton}
            onClick={() => handleAddToCalendar('apple')}
            aria-label={t('guest_app_calendar_apple_aria')}
          >
            <img
              src={AppleLogo}
              alt={t('guest_app_calendar_apple_alt')}
              className={styles.calendarIconImage}
            />
          </button>
        )}
        <button
          type="button"
          className={styles.calendarIconButton}
          onClick={() => handleAddToCalendar('google')}
          aria-label={t('guest_app_calendar_google_aria')}
        >
          <img
            src={GoogleLogo}
            alt={t('guest_app_calendar_google_alt')}
            className={styles.calendarIconImage}
          />
        </button>
        <button
          type="button"
          className={styles.calendarIconButton}
          onClick={() => handleAddToCalendar('outlook')}
          aria-label={t('guest_app_calendar_outlook_aria')}
        >
          <img
            src={OutlookLogo}
            alt={t('guest_app_calendar_outlook_alt')}
            className={styles.calendarIconImage}
          />
        </button>
      </div>
    </div>
  );
}
